export default __webpack_public_path__ + "static/media/5.a0ba4c30.jpeg";